import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('exportDropdownTrigger');

    return {
        EXPORT: t('export')
    };
};

export default useTranslation;
